<template>
    <div class="sidebar-content">
        <b-form @submit.prevent="assignClients">
            <div class="form-section">
                <h6 class="section-title">Параметры назначения</h6>
                <div class="row">
                    <div class="col-md-12">
                        <b-form-group label="Агентская компания *" label-for="agent_company_id">
                            <b-form-select
                                id="agent_company_id"
                                v-model="form.agent_company_id"
                                :options="agentCompanyOptions"
                                :disabled="loading"
                                required
                            />
                            <b-form-text v-if="loading">
                                <i class="fas fa-spinner fa-spin"></i> Загрузка списка компаний...
                            </b-form-text>
                        </b-form-group>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <b-form-group label="Количество клиентов" label-for="limit">
                            <b-form-input
                                id="limit"
                                v-model="form.limit"
                                type="number"
                                min="1"
                                max="200"
                                :state="validateState('limit')"
                            />
                            <b-form-text>Максимум 200 клиентов за раз</b-form-text>
                        </b-form-group>
                    </div>
                </div>
            </div>

            <div class="form-section">
                <h6 class="section-title">Информация о назначении</h6>
                <div class="info-box">
                    <h6>Правила назначения:</h6>
                    <ul class="easy-list">
                        <li>Будут назначены только не назначенные клиенты</li>
                        <li>Клиенты должны быть из региона агентской компании</li>
                        <li>Клиенты не должны быть в основной базе компаний</li>
                        <li>По умолчанию назначается 150 клиентов</li>
                    </ul>
                </div>
            </div>

            <div class="form-actions-bottom">
                <b-button
                    variant="secondary"
                    @click="$emit('input', false)"
                    class="mr-2"
                >
                    Отмена
                </b-button>
                <b-button
                    variant="primary"
                    @click="assignClients"
                    :disabled="!isFormValid"
                >
                    Назначить клиентов
                </b-button>
            </div>
        </b-form>
    </div>
</template>

<script>
import { API_AGENT_COMPANY } from '@/constants/api'

export default {
    name: 'ColdClientAssignModal',
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: {
                agent_company_id: '',
                limit: 150
            },
            agentCompanyOptions: [
                { value: '', text: 'Выберите агентскую компанию' }
            ],
            errors: {},
            loading: false
        }
    },
    computed: {
        isFormValid() {
            return this.form.agent_company_id && this.form.limit > 0 && this.form.limit <= 200
        }
    },
    watch: {
        value(newVal) {
            if (newVal) {
                this.loadAgentCompanies()
            } else {
                this.resetForm()
            }
        }
    },
    mounted() {
        this.loadAgentCompanies()
    },
    methods: {
        async loadAgentCompanies() {
            try {
                this.loading = true
                
                // Загружаем список агентских компаний через API
                const response = await api.call('get', API_AGENT_COMPANY, {
                    params: {
                        per_page: 1000, // Загружаем все компании
                        check_status: 'approved' // Только одобренные компании
                    }
                })
                
                if (response.data && response.data.data) {
                    this.agentCompanyOptions = [
                        { value: '', text: 'Выберите агентскую компанию' },
                        ...response.data.data.map(company => ({
                            value: company.id,
                            text: `${company.full_name} / ${company.inn} (${(company.region && company.region.fullname) || 'Регион не указан'})`
                        }))
                    ]
                }
            } catch (error) {
                console.error('Ошибка загрузки агентских компаний:', error)
                this.$bvToast.toast('Ошибка загрузки списка агентских компаний', {
                    title: 'Ошибка',
                    variant: 'danger'
                })
            } finally {
                this.loading = false
            }
        },
        resetForm() {
            this.form = {
                agent_company_id: '',
                limit: 150
            }
            this.errors = {}
        },
        validateState(field) {
            return this.errors[field] ? false : null
        },
        async assignClients() {
            try {
                await this.$api.coldClients.assignToAgent(this.form)
                
                this.$emit('assigned')
                this.$bvToast.toast(
                    `Клиенты успешно назначены агенту`,
                    {
                        title: 'Успех',
                        variant: 'success'
                    }
                )
            } catch (error) {
                console.error('Ошибка назначения клиентов:', error)
                if (error.response?.data?.message) {
                    this.$bvToast.toast(error.response.data.message, {
                        title: 'Ошибка',
                        variant: 'danger'
                    })
                } else {
                    this.$bvToast.toast('Ошибка при назначении клиентов', {
                        title: 'Ошибка',
                        variant: 'danger'
                    })
                }
            }
        }
    }
}
</script>

<style scoped>
.sidebar-content {
    padding: 1rem;
    height: 100%;
    overflow-y: auto;
}

.form-section {
    margin-bottom: 2rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #eee;
}

.form-section:last-child {
    border-bottom: none;
}

.section-title {
    color: #495057;
    font-weight: 600;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #0d6348;
}

.info-box {
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    padding: 1rem;
    margin-top: 1rem;
}

.info-box h6 {
    margin-bottom: 0.5rem;
    color: #495057;
}

.info-box ul {
    margin-bottom: 0;
    padding-left: 1.5rem;
}

.info-box li {
    margin-bottom: 0.25rem;
    color: #6c757d;
}

.form-actions-bottom {
    position: absolute;
    width: 100%;
    padding: 20px 25px;
    left: 0;
    bottom: 0;
    background: #fff;
    border-top: 1px solid #eee;
    text-align: right;
}
</style>
